import { render } from "./BenchmarkDetail.vue?vue&type=template&id=1be70984"
import script from "./BenchmarkDetail.vue?vue&type=script&lang=js"
export * from "./BenchmarkDetail.vue?vue&type=script&lang=js"

import "./BenchmarkDetail.vue?vue&type=style&index=0&id=1be70984&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__